<template>
  <div class="container container-main bg-white flex">
    <!-- Nav -->

    <nav class="relative cursor-pointer group z-10">
      <!-- Nav button -->

      <div class="flex items-center justify-center gap-2 bg-background w-[233px] py-[9px] rounded-[0.625rem] group-hover:rounded-b-none">
        <span class="text--btn text-primary uppercase">
          {{ $t("common.catalog") }}
        </span>
        <i-material-symbols-keyboard-arrow-down-rounded class="text-primary text-[26.67px] group-hover:rotate-180" />
      </div>

      <!-- Menu -->
      <ul
        v-if="categoriesStore.getCategories.length"
        class="hidden group-hover:flex flex-col max-h-max absolute top-full left-0 right-0 pt-4 pb-3 items-start bg-background rounded-b-[10px]"
      >
        <li
          v-for="category in categoriesStore.getCategories"
          :key="category.code"
          class="w-full py-3 px-6 hover:bg-transparency group/category"
        >
          <span class="text group-hover/category:text-primary-hover">{{ category.name }}</span>

          <!-- Sub menu -->
          <div
            class="hidden group-hover/category:block w-[300%] absolute top-0 left-[calc(100%-5px)] bottom-0 bg-background pt-4 pb-3 rounded-r-[10px] overflow-auto"
          >
            <ul class="flex flex-col flex-wrap h-full">
              <li v-for="subCatgeroy in category.subCategories" :key="subCatgeroy.code" class="w-[200px] h-max py-3 px-6 group/subCategory">
                <router-link
                  v-if="subCatgeroy.abstractProductList.length"
                  :to="{
                    name: '/products/abstractProductCode',
                    params: {
                      abstractProductCode: subCatgeroy.abstractProductList[0].code,
                    },
                  }"
                  class="text--sm group-hover/subCategory:text-primary-hover group-hover/subCategory:underline"
                >
                  {{ subCatgeroy.name }}
                </router-link>
                <span v-else class="text--sm text-gray">
                  {{ subCatgeroy.name }}
                </span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>

    <!--  -->

    <!-- Promo -->
    <ul class="flex items-center">
      <li class="px-5 border-r-2 border-background last:border-none">
        <span class="text--md uppercase">{{ $t("common.bestsellers") }}</span>
      </li>
      <li class="px-5 border-r-2 border-background last:border-none">
        <span class="text--md uppercase">{{ $t("common.for-comfortable-study") }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useCategoriesStore } from "../../../stores/categoriesStore"

const categoriesStore = useCategoriesStore()
</script>

<style lang="scss" scoped></style>
